import { render } from "./ChosenTask.vue?vue&type=template&id=a0f2b67e&scoped=true"
import script from "./ChosenTask.vue?vue&type=script&lang=js"
export * from "./ChosenTask.vue?vue&type=script&lang=js"

import "./ChosenTask.vue?vue&type=style&index=0&id=a0f2b67e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a0f2b67e"

export default script